import { DefaultRouter } from "./routes";

import "./App.css";
import GlobalNotification from "./dialogs/boxes/Notification/GlobalNotifikacion";

function App() {
    return (
        <>
            <DefaultRouter />;
            <GlobalNotification />
        </>
    );
}

export default App;
